import {PRODUKT_CARDS} from "../constants/produkt";

const getProductNameById = (id: string | null): string => {
  const prodId = String(id);
  return PRODUKT_CARDS.find((k) => k.id === prodId)?.title || prodId;
};

export default getProductNameById;
